'use client';

import { FONT_TEXT } from '@/app/fonts';
import { ShareableChart } from '@/components/blog/ShareableChart';

const channels = [
  { name: 'SEO / Organic', cpl: '$0*', timeToResults: '3–6 months', scalability: 'High (compounds)', conversion: '20–30%', bestFor: 'Long-term growth', color: '#10b981' },
  { name: 'Google Ads', cpl: '$20–$80', timeToResults: 'Immediate', scalability: 'High (budget-dependent)', conversion: '3–5%', bestFor: 'High-intent buyers', color: '#294bfd' },
  { name: 'Facebook/Meta', cpl: '$4–$30', timeToResults: 'Immediate', scalability: 'High', conversion: '2–5%', bestFor: 'Volume + top of funnel', color: '#294bfd' },
  { name: 'Agent Referrals', cpl: '$0', timeToResults: '1–3 months', scalability: 'Medium', conversion: '40–60%', bestFor: 'Highest close rate', color: '#ff34a7' },
  { name: 'Database/Email', cpl: '$0', timeToResults: '1–2 weeks', scalability: 'Medium', conversion: '10–20%', bestFor: 'Past client reactivation', color: '#ff34a7' },
];

export function LeadChannelComparison() {
  return (
    <ShareableChart title="Lead Channel Comparison 2026">
      <h3 className="text-lg font-bold text-gray-900 mb-1" style={{ fontFamily: FONT_TEXT }}>
        Lead Generation Channels Compared
      </h3>
      <p className="text-sm text-gray-500 mb-4" style={{ fontFamily: FONT_TEXT }}>
        No single channel wins — the best LOs blend all of them
      </p>

      <div className="overflow-x-auto">
        <table className="w-full text-sm" style={{ fontFamily: FONT_TEXT }}>
          <thead>
            <tr className="border-b-2 border-gray-200">
              <th className="text-left py-3 pr-4 font-semibold text-gray-900">Channel</th>
              <th className="text-left py-3 px-3 font-semibold text-gray-900">CPL</th>
              <th className="text-left py-3 px-3 font-semibold text-gray-900">Time to Results</th>
              <th className="text-left py-3 px-3 font-semibold text-gray-900">Lead-to-Close Rate</th>
              <th className="text-left py-3 px-3 font-semibold text-gray-900">Best For</th>
            </tr>
          </thead>
          <tbody>
            {channels.map((ch) => (
              <tr key={ch.name} className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
                <td className="py-3 pr-4">
                  <div className="flex items-center gap-2">
                    <div className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: ch.color }} />
                    <span className="font-medium text-gray-900">{ch.name}</span>
                  </div>
                </td>
                <td className="py-3 px-3 text-gray-700 font-medium">{ch.cpl}</td>
                <td className="py-3 px-3 text-gray-600">{ch.timeToResults}</td>
                <td className="py-3 px-3 font-medium" style={{ color: ch.color }}>{ch.conversion}</td>
                <td className="py-3 px-3 text-gray-600">{ch.bestFor}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="text-xs text-gray-400 mt-3" style={{ fontFamily: FONT_TEXT }}>
        *SEO requires platform/time investment · Source: leadpops.com · Industry data, HousingWire (2025–2026)
      </p>
    </ShareableChart>
  );
}
